import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	ICreateSubcategoryModalContext,
	CreateSubcategoryModalContext,
} from '../../../../../../../../../createSubcategoryModalContext/createSubcategoryModalState/createSubcategoryModalContext';
import { Form, Checkbox } from 'antd';
import style from './HideSubCategoryCheckbox.module.scss';

const HideSubCategoryCheckbox: React.FC = () => {
	const { changeSubCategoryVisibilityStatus, isHiddenSubCategory } =
		useContext<ICreateSubcategoryModalContext>(CreateSubcategoryModalContext);

	return (
		<Form.Item name="isHiddenSubCategory">
			<Checkbox
				onChange={(e) => changeSubCategoryVisibilityStatus(e.target.checked)}
				checked={isHiddenSubCategory}>
				<Text
					className={style.checkboxName}
					translationNameSpace="form"
					translationKey="subcategoryIsHiddenLabel"
				/>
			</Checkbox>
		</Form.Item>
	);
};

export default HideSubCategoryCheckbox;
